module.exports = __webpack_public_path__ + "static/media/ios-watch.1c1a661a.svg";